export default __webpack_public_path__ + "static/media/Sri badrika asharam.d13afbd1.svg";